/*
 *
 *  * Copyright (c) 2020 General Electric Company. All rights reserved.
 *  *
 *  * The copyright to the computer software herein is the property of
 *  * General Electric Company. The software may be used and/or copied only
 *  * with the written permission of General Electric Company or in accordance
 *  * with the terms and conditions stipulated in the agreement/contract
 *  * under which the software has been supplied.
 *
 */
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ModalComponent } from './modal.component';
import { ModalChildComponentDirective } from './modal-child-component.directive';
import { AngularSvgIconModule } from 'angular-svg-icon';
import { FormsModule } from '@angular/forms';
import { TranslateModule } from '@ngx-translate/core';
import { TooltipModule } from '../tooltip/tooltip.module';
import { AngularResizedEventModule } from 'angular-resize-event';

@NgModule({
  imports: [CommonModule, AngularSvgIconModule, FormsModule, TranslateModule, TooltipModule, AngularResizedEventModule],
  declarations: [ModalComponent, ModalChildComponentDirective],
  entryComponents: [ModalComponent]
})
export class ModalsModule {}
